module.exports = __webpack_public_path__ + "static/media/Facebook.c487804d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Facebook.svg
// module id = 148
// module chunks = 0